import { Exclude, Expose } from "class-transformer";

@Exclude()
export class CreateStaffMemberDto {
    @Expose()
    readonly login: string;

    @Expose()
    readonly email: string;

    @Expose()
    readonly password: string;

    @Expose()
    readonly first_name: string;

    @Expose()
    readonly last_name: string;

    @Expose()
    readonly middle_name: string;

    @Expose()
    readonly phone: string;

    @Expose()
    readonly sub_role?: string;

    @Expose()
    readonly department?: string;

    @Expose()
    readonly work_phone?: string;

    @Expose()
    readonly additional_phone?: string;

    @Expose()
    readonly occupation?: string;

    @Expose()
    readonly birthday?: string;

    @Expose()
    readonly join_date?: string | null;

    @Expose()
    readonly dismiss_date?: string | null;
}
